import { GatewayAuthentication } from "@conformite/gateway";
import { captchaAxiosInstance } from "../utils/captchaAxiosInstance";

export class GatewayAuthApi {
  public static async forgotPassword(
    email: string
  ): Promise<GatewayAuthentication.ForgotPasswordRequestType> {
    const response =
      await captchaAxiosInstance.post<GatewayAuthentication.ForgotPasswordRequestType>(
        `${GatewayAuthentication.forgotPasswordRequestUrl}`,
        {
          email,
        }
      );
    return response.data;
  }

  public static async confirmForgotPassword(
    email: string,
    code: string,
    password: string
  ): Promise<GatewayAuthentication.ConfirmForgotPasswordRequestType> {
    const response =
      await captchaAxiosInstance.post<GatewayAuthentication.ConfirmForgotPasswordRequestType>(
        `${GatewayAuthentication.configForgotPasswordRequestUrl}`,
        {
          email,
          code,
          password,
        }
      );
    return response.data;
  }

  public static async confirmPassword(
    payload: GatewayAuthentication.NewPasswordType
  ) {
    const response =
      await captchaAxiosInstance.post<GatewayAuthentication.SigninResponseType>(
        GatewayAuthentication.newPasswordUrl,
        payload
      );
    return response.data;
  }
}
